import fr from 'vee-validate/dist/locale/fr.json';

export default {
    ...fr,
    names: {
        rpps: 'N° RPPS',
    },
    fields: {
        login: {
            required: "Merci de saisir votre identifiant.",
            email: "Le format de votre E-mail n’est pas valide.",
        },
        pwd: {
            required: "Merci de saisir un mot de passe.",
        },
        pwd1: {
            required: "Merci de saisir votre mot de passe.",
            regex: "Merci de saisir un mot de passe comprenant au minimum 8 caractères comprenant au minimum une majuscule et une minuscule.",
            confirmed: "Vos mots de passe ne sont pas identiques, merci de recommencer.",
        },
        pwd2: {
            required: "Merci de saisir votre mot de passe.",
            regex: "Merci de saisir un mot de passe comprenant au minimum 8 caractères comprenant au minimum une majuscule et une minuscule.",
        },
        rpps: {
            required: "Merci de renseigner votre n° RPPS.",
            length: "Votre n° RPSS n’est pas complet, il doit contenir 11 chiffres."
        },
        profil: {
            required: "Merci de bien vouloir renseigner votre profil.",
        },
        client_arrow: {
            required: "Merci de bien vouloir nous dire si votre établissement est un client du Laboratoire Arrow.",
        },
        field_prenom: {
            required: "Merci de renseigner votre prénom.",
        },
        field_nom: {
            required: "Merci de renseigner votre nom.",
        },
        mail: {
            required: "Merci de renseigner un E-mail valide.",
            email: "Le format de votre E-mail n’est pas valide.",
        },
        field_code_client_arrow: {
            required: "Merci de bien vouloir renseigner votre code client établissement du Laboratoire Arrow.",
            length: "Votre code établissement doit contenir 7 caractères merci de recommencer.",
        },
        field_number_order: {
            required: "Merci de bien vouloir renseigner un n° de commande de moins de 6 mois.",
        },
        field_nom_de_l_etablissement: {
            required: "Merci de renseigner votre le nom de votre établissement.",
        },
        field_adresse: {
            required: "Merci de renseigner votre adresse.",
        },
        field_complement_adresse: {
            required: "Merci de renseigner votre adresse principale.",
        },
        field_code_postal: {
            required: "Merci de renseigner votre code postal.",
        },
        field_ville: {
            required: "Merci de renseigner la ville de votre activité.",
        },
        field_phone: {
            required: "Merci de renseigner le téléphone de l’établissement.",
        },
        sujet: {
            required: "Merci de renseigner le motif de votre demande.",
        },
        message: {
            required: "Merci de nous décrire votre demande.",
        },
        field_adresse_support: {
            required: "Merci de renseigner votre adresse.",
        },
        field_ville_support: {
            required: "Merci de renseigner votre ville.",
        },
        field_code_postal_support: {
            required: "Merci de renseigner votre code postal.",
        },
        field_support: {
            required: "Merci de renseigner le(s) support(s) souhaité(s).",
        },
        field_quantite_support: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_0: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_1: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_2: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_3: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_4: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_5: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_6: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_7: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_8: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_9: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_10: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_11: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_12: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_13: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_14: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_15: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_16: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_17: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_18: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_19: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_quantite_support_20: {
            required: "Merci de renseigner la quantité de support souhaitée.",
        },
        field_support_0: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_1: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_2: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_3: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_4: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_5: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_6: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_7: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_8: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_9: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_10: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_11: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_12: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_13: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_14: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_15: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_16: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_17: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_18: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_19: {
            required: "Merci de sélectionner le support souhaitée.",
        },
        field_support_20: {
            required: "Merci de sélectionner le support souhaitée.",
        },
    },
};
